import { render, staticRenderFns } from "./error.vue?vue&type=template&id=34e2e877&scoped=true&lang=pug&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"
import style0 from "./error.scss?vue&type=style&index=0&id=34e2e877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e2e877",
  null
  
)

export default component.exports